export const isWeb = typeof document !== "undefined";
export const isNative = !isWeb;

// For native platforms, we can check specific globals if needed,
// but usually we just care about isWeb vs isNative for common logic.
export const isIOS =
  isNative &&
  typeof global !== "undefined" &&
  (global as any).Platform?.OS === "ios";
export const isAndroid =
  isNative &&
  typeof global !== "undefined" &&
  (global as any).Platform?.OS === "android";
